import { render, staticRenderFns } from "./FrequenciaRespiratoria.vue?vue&type=template&id=0819a9be&"
import script from "./FrequenciaRespiratoria.vue?vue&type=script&lang=js&"
export * from "./FrequenciaRespiratoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports